<template>
  <div class="appHouseholdManage">
    <div class="filters">
      <el-form :inline="true">
        <!-- 选择日期 -->
        <el-form-item :label="$t('lang.lab_RegTime')">
          <el-date-picker v-model="datevalues" type="daterange" :range-separator="$t('lang.lab_to')"
            :start-placeholder="$t('lang.lab_startDate')" :end-placeholder="$t('lang.lab_endDate')"
            value-format="timestamp"></el-date-picker>
        </el-form-item>
        <!-- 选择楼号 -->
        <el-form-item>
          <el-select v-model="floorid" @change="selectUnit">
            <el-option key :label="$t('lang.lab_floorName')" value=''></el-option>
            <el-option v-for="(item,index) in floorList" :key="index" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <!-- 选择单元号 -->
        <el-form-item>
          <el-select v-model="unitid" @change="selectRoom">
            <el-option key :label="$t('lang.lab_unitName')" value=''></el-option>
            <el-option v-for="(item,index) in unitList" :key="index" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <!-- 选择房间号 -->
        <el-form-item>
          <el-select v-model="roomid">
            <el-option key :label="$t('lang.lab_roomName')" value=''></el-option>
            <el-option v-for="(item,index) in roomList" :key="index" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <!-- 身份 -->
        <el-form-item>
          <el-select class="select" v-model="user" :placeholder="$t('lang.APPHOUSEHOLDMANAGE.USERTYPE[0].label')">
            <el-option v-for="item in Identitys" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>       
        <!-- 标签 -->
        <!-- <el-form-item>
          <el-select
            class="select"
            v-model="tag"
            :placeholder="$t('lang.APPHOUSEHOLDMANAGE.TAGS[0].label')">
              <el-option
              v-for="item in tags"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              ></el-option>
          </el-select>
        </el-form-item> -->
        <!-- 关键字 -->
        <el-form-item>
          <el-input class="seachInput" v-model="keyword"
            :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_username')"></el-input>
        </el-form-item>
         <el-form-item>
          <el-checkbox v-model="myLaunch">{{$t('lang.villageall')}}</el-checkbox>
        </el-form-item>
        <el-button type="primary" @click="submit()">{{$t('lang.btn_search')}}</el-button>
        <el-upload class="upload-demo" ref="uploading" action :on-remove="handleRemove" :on-change="handleSuccess"
          :on-exceed="outlimit" :on-error="uploadErr1" :limit="1" accept=".xlsx,.xls" :file-list="fileList"
          :auto-upload="false">
          <el-button slot="trigger" size="small" type="primary">{{$t('lang.btn_selectExcel')}}</el-button>
          <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">
            {{$t('lang.feePay.btn_fee_import')}}</el-button>
        </el-upload>
      </el-form>
    </div>
    <el-card>
      <el-button type="primary" slot="header" @click="excelDownloadClick">{{$t('lang.btn_excelDl')}}</el-button>
      <el-table :data="tableData" class="wid100"
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
        :row-class-name="tableRowClassName" @selection-change="handleSelectionChange">
        <!-- checkbox -->
        <el-table-column type="selection" width="55" v-if="appHouseholdManageListcheckbox"></el-table-column>
        <!-- 序号 -->
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px">
        </el-table-column>
        <!-- 用户名 -->
        <el-table-column prop="nickName" :label="$t('lang.lab_username')"></el-table-column>
        <!-- 手机 -->
        <el-table-column prop="mobile" :label="$t('lang.lab_phone')"></el-table-column>
        <!-- 小区 -->
        <el-table-column prop="garden.name" :label="$t('lang.lab_village')"></el-table-column>
        <!-- 楼号 -->
        <el-table-column prop="garden.grids.houseName" :label="$t('lang.lab_buildingnum')"></el-table-column>
        <!-- 单元号 -->
        <el-table-column prop="garden.grids.unitName" :label="$t('lang.lab_unitnum')"></el-table-column>
        <!-- 房间号 -->
        <el-table-column prop="garden.grids.roomName" :label="$t('lang.lab_roomnum')"></el-table-column>
        <!-- 身份 -->
        <el-table-column prop="garden.userType" :label="$t('lang.lab_identitynum')">
          <template slot-scope="scope">
            <span v-if="scope.row.garden.userType === 1">{{$t('lang.APPHOUSEHOLDMANAGE.USERTYPE[1].label')}}</span>
            <span v-if="scope.row.garden.userType === 2">{{$t('lang.APPHOUSEHOLDMANAGE.USERTYPE[2].label')}}</span>
            <span v-if="scope.row.garden.userType === 3">{{$t('lang.APPHOUSEHOLDMANAGE.USERTYPE[3].label')}}</span>
          </template>
        </el-table-column>
        <!-- 操作 -->
        <el-table-column prop="operation" :label="$t('lang.lab_operation')" fixed="right"
          :width="require('@/config/enum').opr_width2">
          <template slot-scope="scope">
            <el-button @click="change(scope.row)">{{$t('lang.btn_modify')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 添加页码 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
    </el-card>
    <!-- 修改积分dialog -->
    <el-dialog :title="$t('lang.btn_editIntegral')" :visible.sync="dialogVisible" :close-on-click-modal="false" center
      top="130px" width="600px">
      <el-form ref="integral" :rules="rules" :model="integral">
        <el-form-item class="t-c">
          <p class="integralHave">{{$t('lang.lab_Have')}}<span>{{haveIntegralNum}}</span></p>
          <el-radio v-model="integral.integralState" label="1">{{$t('lang.addIntegral')}}</el-radio>
          <el-radio v-model="integral.integralState" label="2">{{$t('lang.lessenIntegral')}}</el-radio>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_Integral')" label-width="120px" prop="integralNum">
          <el-input :placeholder="$t('lang.lab_tip')" v-model="integral.integralNum" @keyup.native="number"></el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_Remark')" label-width="120px" prop="integralRemark">
          <el-input maxlength='200' v-model="integral.integralRemark"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cencelIntegral">{{$t('lang.btn_cancel')}}</el-button>
        <el-button type="primary" @click="saveIntegral(integral)">{{$t('lang.btn_save')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  // 引入富文本title汉字
  import {
    excelDownload
  } from '../../../config/download.js'
  /**
   *@ClassName:appIntegralManages
   *@Description:app积分管理
   *@author:杜斌
   *@Copyright:格众科技
   *@date:2020-12-02
   */
  import { mapGetters } from 'vuex'
  
  export default {
    name:'/manage/main.integral',
    data() {
      return {
        gardenId:'',
        multipleSelection: [], // 多选框
        datevalues: [], // 开始结束时间绑定值
        floorid: '', // 楼层绑定值
        floorList: [], // 楼层下拉列表
        unitid: '', // 单元绑定值
        unitList: [], // 单元下拉列表
        roomid: '', // 房间绑定值
        roomList: [], // 房间下拉列表
        user: '0', // 身份
        tag: '0', // 标签
        keyword: '', // 手机或序号内容input
        pageCount: 0, // 总页数
        pageNo: 1, // 第几页
        pageSize: 10, // 每页显示数
        tableData: [], // 列表数组
        type: 1, // 楼号单元号房间号区分
        parentId: '',
        myLaunch: '', // 我发起的
        uploadFile: '',
        fileList: [], // 上传
        Identitys: this.$i18n.t('lang.APPHOUSEHOLDMANAGE.USERTYPE'), // 身份列表
        tags: this.$i18n.t('lang.APPHOUSEHOLDMANAGE.TAGS'), // 标签列表
        appHouseholdManageListcheckbox: require('@/config/enum').appHouseholdManageListcheckbox, // 是否隐藏复选框
        dialogVisible: false, // 修改积分dialog状态
        haveIntegralNum: '', // 当前拥有积分数
        integral: {
          userId: '', // 用户id
          integralState: '1', // 积分状态（1：增加；2：减少）
          integralNum: '', // 修改积分数
          integralRemark: '', // 修改积分备注
        },
        rules: {
          integralNum: [{
            required: true,
            message: this.$i18n.t('lang.lab_IntegralNum'),
            trigger: 'blur'
          }],
          integralRemark: [{
            required: true,
            message: this.$i18n.t('lang.lab_integralTxt'),
            trigger: 'blur'
          }]
        }
      }
    },
    created() {
      // 初始化
      this.topics()
      // 获取楼号
      this.gardenGrids(this.gardenId)
    },
    // computed: {
    //   ...mapGetters(['gardenId'])
    // },
    // 监听改变小区编号
    watch: {
      gardenId: function (newFlag, oldFlag) {
        this.gardenChange()
      }
    },
    methods: {
      // ID序号功能
      indexMethod(index) {
        return (this.pageNo - 1) * this.pageSize + index + 1
      },
      // 列表斑马线
      tableRowClassName({
        row,
        rowIndex
      }) {
        return rowIndex % 2 === 0 ? 'row-dark' : ''
      },
      // 添加多选框
      handleSelectionChange(val) {
        this.multipleSelection = val
      },
      // 文件上传数量超过提醒
      outlimit() {
        this.$message.warning(this.$i18n.t('lang.lab_uploadWarning'))
      },
      // 移除附件
      handleRemove(file, fileList) {
        console.log('Remove Success!', file, fileList)
        this.fileList = []
        this.uploadFile.length = 0
      },
      // 文件上传
      handleSuccess(e) {
        console.log('Upload Success!', e)
        this.uploadFile = e.raw
      },
      // 导入业主
      submitUpload() {
        if (this.uploadFile.length < 1) {
          this.$message.warning(this.$i18n.t('lang.lab_pleaseSeletcUploadDoc'))
        } else {
          let formData = new FormData()
          formData.append('excelFile', this.uploadFile)
          let loading = this.$loading()
          this.$postFormData(`/inputSklUserPoint/`, formData).then(
            res => {
              loading.close()
              this.$message.success(this.$i18n.t('lang.lab_uploadSuccess'))
              // this.commit()
              this.fileList = []
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
        }
      },
       // 上传文件的断网
      uploadErr1() {
        if (!navigator.onLine || window.navigator.onLine === false) {
          const loading = this.$loading()
          setTimeout(() => {
            loading.close()
            this.$message.error(this.$i18n.t('lang.lab_Online'))
          }, 500)
        }
      },
      // 表格下载
      excelDownloadClick() {
        if (navigator.onLine) {
          // Excel表头
          const tHeader = [
            this.$i18n.t('lang.lab_username'),
            this.$i18n.t('lang.lab_phone'),
            this.$i18n.t('lang.lab_village'),
            this.$i18n.t('lang.lab_buildingnum'),
            this.$i18n.t('lang.lab_unitnum'),
            this.$i18n.t('lang.lab_roomnum'),
            this.$i18n.t('lang.lab_identitynum'),
            this.$i18n.t('lang.lab_tags'),
          ]
          // 对应table数据的列字段名
          let newArr = []
          let userType = ''
          let houseName = ''
          let unitName = ''
          let roomName = ''
          if (this.tableData.length > 0) {
            for (let i = 0; i < this.tableData.length; i++) {
              // 判断楼号单元房间号是否存在
              if (this.tableData[i].garden.grids) {
                houseName = this.tableData[i].garden.grids.houseName
                unitName = this.tableData[i].garden.grids.unitName
                roomName = this.tableData[i].garden.grids.roomName
              }
              // 判断身份
              if (this.tableData[i].garden.userType === 1) {
                userType = this.$i18n.t('lang.APPHOUSEHOLDMANAGE.USERTYPE[1].label')
              } else if (this.tableData[i].garden.userType === 2) {
                userType = this.$i18n.t('lang.APPHOUSEHOLDMANAGE.USERTYPE[2].label')
              } else if (this.tableData[i].garden.userType === 3) {
                userType = this.$i18n.t('lang.APPHOUSEHOLDMANAGE.USERTYPE[3].label')
              }
              newArr.push({
                'nickName': this.tableData[i].nickName,
                'mobile': this.tableData[i].mobile,
                'garden.name': this.tableData[i].garden.name,
                'garden.grids.houseName': houseName,
                'garden.grids.unitName': unitName,
                'garden.grids.roomName': roomName,
                'garden.userType': userType,
                'tag': this.tableData[i].tag
              })
            }
          }
          const filterVal = ['nickName', 'mobile', 'garden.name', 'garden.grids.houseName', 'garden.grids.unitName',
            'garden.grids.roomName', 'garden.userType', 'tag'
          ]
          excelDownload(tHeader, filterVal, newArr, this.$i18n.t('lang.lab_appUsermanagement'))
        } else {
          this.$message.error(this.$i18n.t('lang.lab_Online'))
        }
      },
      // 改变小区
      gardenChange() {
        this.floorid = ''
        this.topics()
        this.unitid = ''
        this.roomid = ''
        this.unitList = ''
        this.roomList = ''
        this.type = 1
        this.gardenGrids(this.gardenId)
      },
      // 获取楼号单元号房间号
      gardenGrids(parentId) {
        let loading = this.$loading()
        this.$get(`/gardenGrids?type=${this.type}&parentId=${parentId}&pageNo=1&pageSize=999`).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              if (this.type === 1) {
                this.floorList = res.list
              } else if (this.type === 2) {
                this.unitList = res.list
                this.roomList = ''
                if (this.floorid === '') {
                  this.unitList = ''
                  this.roomList = ''
                }
              } else if (this.type === 3) {
                this.roomList = res.list
                if (this.unitid === '') {
                  this.roomList = ''
                }
              }
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      topics() {
        var startTs = ''
        var endTs = ''
        if (this.datevalues != null) {
          if (this.datevalues.length > 0) {
            startTs = this.datevalues[0]
            endTs = this.datevalues[1]
          }
        }
        if (this.myLaunch === true) {
          this.gardenId = 0
        } else {
          this.gardenId = this.$store.getters.gardenId
        }
        let loading = this.$loading()
        this.$get(
          `/users?pageNo=${this.pageNo}&pageSize=${this.pageSize}&gardenId=${this.gardenId}&houseId=${this.floorid}&unitId=${this.unitid}&roomId=${this.roomid}&userType=${this.user}&key=${this.keyword}&tagId=${this.tag}&startTs=${startTs}&endTs=${endTs}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.tableData = res.list
              this.pageCount = res.pageCount
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      change(row) {
        let loading = this.$loading()
        this.integral.userId = row.id
        let params = {
          userId: row.id,
        }
        this.$get(`/getSklUserInfo`, params)
          .then(res => {
            if (res.data.rtCode == '40204') {
              this.$message.error(this.$i18n.t('lang.NoMember'))
              loading.close()
            } else {
              this.dialogVisible = true
              this.haveIntegralNum = res.data.rtData.dtObj.points
              loading.close()
            }
          })
          .catch(err => {
            console.log(err)
            loading.close()
            this.$message.error(this.$i18n.t('lang.IntegralLose'))
          })
      },

      // 提交
      submit() {
        this.pageNo = 1
        this.topics()
      },
      // 通过楼层选择单元号
      selectUnit() {
        this.type = 2
        this.gardenGrids(this.floorid)
        this.unitid = ''
        this.roomid = ''
      },
      // 通过单元选择房间号
      selectRoom() {
        this.type = 3
        this.gardenGrids(this.unitid)
        this.roomid = ''
      },
      // 翻页
      handleCurrentChange(val) {
        this.pageNo = val
        this.topics()
      },
      // 切换每页显示多少数据
      handleSizeChange(val) {
        this.pageNo = 1
        this.pageSize = val
        this.topics()
      },
      // 积分输入（只能是正整数）
      number() {
        // eslint-disable-next-line no-useless-escape
        this.integral.integralNum = this.integral.integralNum.replace(/[^\.\d]/g, '')
        this.integral.integralNum = this.integral.integralNum.replace('.', '')
      },
      // 取消修改积分
      cencelIntegral() {
        this.dialogVisible = false
        this.integral.userId = ''
        this.integral.integralState = '1'
        this.integral.integralNum = ''
        this.integral.integralRemark = ''
      },
      // 保存修改积分
      saveIntegral(integral) {
        this.$refs.integral.validate((valid) => {
          if (valid) {
            let loading = this.$loading()
            let params = {
              userId: integral.userId,
              type: integral.integralState,
              point: integral.integralNum,
              remark: integral.integralRemark,
            }
            this.$get(`/sklPoint`, params)
              .then(res => {
                console.log(res)
                loading.close()
                this.dialogVisible = false
                this.integral.userId = ''
                this.integral.integralState = '1'
                this.integral.integralNum = ''
                this.integral.integralRemark = ''
              })
              .catch(err => {
                console.log(err)
                loading.close()
                this.$message.error(this.$i18n.t('lang.IntegralEditLose'))
              })
          } else {
            return false
          }
        })
      }
    }
  }
</script>

<style lang='scss'>
  .el-dialog .el-form .el-form-item.t-c {
    text-align: center;
  }

  .integralHave {
    font-size: 16px;
  }

  .integralHave span {
    font-size: 30px;
    font-weight: bold;
    color: #010101;
  }
</style>
